import React from 'react';
import styled from 'styled-components';
import autobind from 'autobind-decorator';
import { OverlayIni, Spinner, MenuOverlay, Menu, HeadLink } from './StyledComponents';
import { PageFooter, PageHeaderHome } from './PageComponents';
import { CloseDiv } from './Portfolio';


const dhaAspect = 1920 / 913; 
let ini=true;
export interface HomeState {
    overlay:String;
    menuOverlay: String;
    bannerHeight:String;
    dhaWidth: string;
    dhaHeight: string;
    pathClass:string;
}

export const BannerHead = styled('div')({
    display:'flex',
    flexDirection: 'column',
    alignItems:'flex-end',
    justifyContent:'flex-start',
   // backgroundImage: `url(${require("./Images/DHASplash1.jpg")})`,
    background : '#ff0000',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    width: '100%',
    marginBottom: '48px',
    textAlign:'center',
    position:'relative',
    left:'0',
    top:'0',

    '@media screen and (max-width: 1024px)': {
        justifyContent:'center',
    }

})
export const BannerImg = styled('img')({
    marginTop: '76px'
})

export const BannerSVG = styled('svg')({
    backgroundColor:'#FFF',
    display: 'flex', 
    flexDirection: 'row',
    alignItems: 'center', 
    justifyContent: 'center',
    width: '100%',
    height:'125px',
    '@media screen and (max-width: 960px)': {
        height:'75px',
    },

    '@media screen and (max-width: 670px)': {
        height:'50px',
    }
})

export const MainBannerHeader = styled('text')({
    fontFamily:'STIXGeneralRegular',
    fontSize:'85px',
    color:'#000000', 
    textTransform: 'uppercase',
    textAnchor:'middle',
    dominantBaseline:'middle',
    '@media screen and (max-width: 960px)': {
        fontSize:'45px',
    },

    '@media screen and (max-width: 670px)': {
        fontSize:'32px',
    }
})


export const SecondBannerHeader = styled('h2')({
    fontSize:'32px',
    margin:'0px 20px 20px 20px',
    color:'rgb(40,40,40)',
    textTransform: 'uppercase'
})

export const ThirdBannerHeader = styled('h2')({
    fontSize:'32px',
    margin:'0px 20px 20px 20px',
    color:'rgb(40,40,40)',
    textTransform: 'uppercase'
})

export const MainBannerTagLine = styled('p')({
    fontWeight: 600,
    fontSize:'24px',
    color:'rgb(235,235,235)',
    textTransform: 'uppercase',
    margin:'30px 0px'
})

export const Stripe = styled('div')({
    display:'flex',
    margin:'0px 40px'
})

export const StripeHead = styled('h5')({
    color:'#6C6C6C',
    borderBottom:'1px solid #E0E0E0',
    margin: '0px 40px',
    paddingBottom:'30px',
    fontFamily:'STIXGeneralRegular',
})

export const LeftDiv = styled('div')({
    textAlign:'start',
    width:'50%'
})
export const RightDiv = styled('div')({
    textAlign:'end',
    width:'50%'
})

export const StripePara = styled('div')({
    color:'#6C6C6C',
    margin:'30px 0px',
    '> p':{
        margin:'10px 0px',
        fontFamily:'Arno Pro',
        '> a':{
            textDecoration: 'none',
            color:'#6C6C6C',
            fontFamily:'Arno Pro',
        }
    }
    
})


class Home extends React.Component<{},HomeState>{
    
    state={
        overlay:'',
        menuOverlay: '',
        bannerHeight:`${window.innerHeight}px`,
        dhaWidth: '0px',
        dhaHeight: '0px',
        pathClass: ini?"load":"pathEnd"
    }

    @autobind
    toggleOverlay(){
        if(this.state.overlay===''){
            this.setState({
                overlay:'overlay',
            })
            
        }
        else{
            this.setState({
                overlay:''
            })
        }
    }

    @autobind
    handleResize() {
        var height = window.innerHeight - 180;
        var width = height * dhaAspect; 

        var maxWidth = Math.max(window.innerWidth - 64, window.innerWidth * 0.95);

        if(width > maxWidth) {
            width = maxWidth; 
            height = width / dhaAspect;
        }
        var bannerHeight = Math.max(height + 180, window.innerHeight);
        if(window.innerWidth > 960) {
            bannerHeight = height + 180;
        }
        this.setState({
            dhaWidth: `${width}px`, 
            dhaHeight: `${height}px`,
            bannerHeight: `${bannerHeight}px`
        })

    }


    loadImage(path: string): Promise<void> {
        var resolve = null; 
        var retPromise = new Promise<void>(r => {
            resolve = r;
        })
        
        var img = new Image(); 
        img.onload = ()=> {
            console.log(`image loaded: ${path}`);
            resolve();
        };
        img.src = path;
        return retPromise;
    }

    @autobind
    toggleOverlayMenu(){
        if(this.state.menuOverlay===''){
            this.setState({
                menuOverlay:'overlay',
            })
            
        }
        else{
            this.setState({
                menuOverlay:''
            })
        }
    }
    
    async componentDidMount() {
        console.log(ini);
        if(ini) {
            ini = false;

            var img1 = this.loadImage(require("./Images/DHAlogo.png")); 
            var img2 = this.loadImage(require("./Images/DHASplash1.jpg")); 

            await Promise.all([img1, img2]);

            this.setState({pathClass:"path"});   

            setTimeout(()=>{
                this.setState({pathClass:"pathEnd"});                
            },6000);
        }
        
        
        
        window.addEventListener('resize', this.handleResize);
        this.handleResize();

        
    }

    componentWillUnmount(){
        window.removeEventListener('resize', this.handleResize)
    }
    render(){
        return(
            <React.Fragment>
                <PageHeaderHome click={()=>this.toggleOverlayMenu()}/>
                <BannerHead style={{height:this.state.bannerHeight}}>
                    <BannerImg  style={{height:this.state.dhaHeight, width: this.state.dhaWidth}} 
                        alt="DHA" src={require("./Images/DHAlogo.png")}></BannerImg>
                    
                <BannerSVG  >
                    <MainBannerHeader x="50%" y="58%" textLength="90%" >CAPITAL</MainBannerHeader>
                </BannerSVG>
                    
                </BannerHead>

                <StripeHead>Contact Us</StripeHead> 
                <Stripe>
                    <LeftDiv>
                        <StripePara>    
                            <p>E: <a href="mailto:info@dhacap.com" target="_blank">
                                info@dhacap.com</a>
                            </p>
                            <p>P: (212) 981-1600</p>
                        </StripePara>
                    </LeftDiv>
                    <RightDiv>
                        <StripePara>
                            {/* <p>101 Ave of the Americas</p>
                            <p>9th Floor</p>
                            <p>New York. NY 10013</p> */}
                           
                        </StripePara>
                    </RightDiv>
                </Stripe>
                <PageFooter />
                <OverlayIni className={this.state.pathClass!="pathEnd"?"overlay":""}>
                    {this.state.pathClass=="load"?
                    <Spinner></Spinner>
                    :
                    this.state.pathClass!="pathEnd"?
                    <svg width={this.state.dhaWidth} height={this.state.dhaHeight} viewBox="0 0 1200 571" fill="#FFF" xmlns="http://www.w3.org/2000/svg">
                        <defs>
                            <pattern id="img1" patternUnits="userSpaceOnUse" width="100%" height="100%">
                                {/* <image preserveAspectRatio="none" xlinkHref={require("./Images/DHASplash1.jpg")} x="0" y="0" width="100%" height="100%" /> */}
                                <image preserveAspectRatio="none" xlinkHref={require("./Images/red.jpg")} x="0" y="0" width="100%" height="100%" />
                            </pattern>
                        </defs>
                        <path  className={this.state.pathClass} stroke="#FFF" strokeWidth="2" strokeMiterlimit="10" d="M0 285.5V0H96.0098C190.119 0 192.22 0 198.42 2C201.921 3.2 207.921 4.5 211.622 5C221.723 6.3 229.924 7.7 235.024 9C237.524 9.6 241.125 10.5 243.025 11C266.027 16.8 293.23 28 313.032 40C321.333 45.1 338.335 56.9 342.735 60.6C343.835 61.7 346.836 64.1 349.236 66C360.237 74.7 383.539 99.7 395.04 115.1C396.441 116.9 400.241 121.3 403.441 124.8C406.742 128.2 409.942 131.8 410.642 132.8C411.742 134.2 411.942 122.6 412.042 67.3V0H458.547H505.052V110V220H626.064H747.077V110V0H793.581H840.086L840.286 181.2C840.586 350.7 840.686 362.5 842.286 362.8C843.486 363 844.587 361.7 846.087 358.3C847.287 355.7 850.187 349.5 852.587 344.5C861.388 326.1 865.089 317.9 865.089 317C865.089 316.4 865.589 316 866.089 316C866.689 316 867.089 315.5 867.089 314.9C867.089 314.2 868.589 310.5 870.489 306.6C877.99 290.8 883.491 279.2 886.291 273C887.991 269.4 891.291 262.2 893.792 257C896.292 251.8 900.192 243.5 902.592 238.5C904.893 233.6 909.093 224.8 911.893 219C914.594 213.2 918.494 204.9 920.594 200.5C922.695 196.1 926.495 188 929.095 182.5C934.096 172 939.296 161 945.597 147.5C947.697 143.1 951.497 135 954.098 129.5C962.899 110.9 966.899 102.5 971.4 93C977.1 80.8 982.701 69.1 991.202 51.1C995.002 43.2 998.102 36.6 998.102 36.5C998.102 36.3 1001.2 29.7 1005 21.8C1008.7 13.9 1012.6 5.8 1013.6 3.8L1015.3 0H1032.61H1050.01L1053.51 7.4C1055.51 11.5 1057.11 15.1 1057.11 15.3C1057.11 15.6 1058.61 19.1 1060.51 23.2C1062.31 27.2 1064.81 32.8 1066.01 35.5C1067.21 38.3 1069.11 42.3 1070.11 44.5C1073.01 50.6 1077.11 60 1077.11 60.5C1077.11 60.7 1078.71 64.4 1080.71 68.7C1082.71 73 1085.01 78.1 1085.81 80C1086.71 81.9 1088.71 86.4 1090.31 90C1091.91 93.6 1093.61 97.4 1094.11 98.5C1098.61 108.5 1109.91 133.8 1112.21 138.8C1113.81 142.3 1115.11 145.3 1115.11 145.5C1115.11 145.7 1116.71 149.4 1118.71 153.7C1120.71 158 1122.92 162.9 1123.62 164.5C1124.42 166.2 1126.62 171 1128.52 175.3C1130.52 179.5 1132.12 183.2 1132.12 183.4C1132.12 183.9 1142.92 207 1144.12 209.2C1144.62 210.2 1147.12 215.3 1149.52 220.7C1153.52 229.6 1157.92 238.9 1177.62 279.5C1185.22 295.2 1196.22 318.2 1198.52 323C1200.02 326.2 1200.12 336.1 1199.92 433L1199.62 539.5L1196.52 533C1194.82 529.4 1190.82 521.1 1187.72 514.5C1176.72 491.3 1162.02 462.7 1157.72 456.1C1152.22 447.6 1147.22 442.8 1139.62 439L1133.62 436L1063.61 435.5C1025.11 435.2 976.7 435.3 956.098 435.7L918.594 436.5L913.294 439.2C902.792 444.6 902.792 444.6 883.391 488C879.89 496 876.09 504.3 875.09 506.5C874.09 508.7 871.589 514.3 869.589 519C867.589 523.7 865.289 528.9 864.589 530.5C862.688 534.7 856.088 549.9 854.588 553.5C853.887 555.2 851.787 559.8 850.087 563.8L846.787 571H796.982H747.077V441V311H626.064H505.052V441V571H458.547H412.042L411.842 507L411.542 443L405.342 450.8C397.341 460.9 388.84 470.3 377.039 482C362.937 496.1 356.737 501.6 341.535 513C307.131 538.9 268.327 557.4 225.823 568.1L214.222 571H107.111H0V285.5ZM164.217 489.5C183.819 487.8 202.921 484.6 217.522 480.4C250.626 471 281.329 452.3 301.731 429.2C305.431 425 308.732 421.3 309.032 421C309.832 420.3 321.233 404.1 323.333 400.8C336.734 379.4 347.936 352 353.336 327.5C354.236 323.7 355.536 317.8 356.236 314.5C357.137 310.4 357.537 300.4 357.437 283.5C357.437 259.9 357.237 257.8 354.636 246.5C346.836 212.6 335.134 187 315.132 160C293.43 130.8 267.727 111.2 236.024 99.5C231.924 98 227.623 96.4 226.523 96C219.422 93.4 215.122 92.3 198.02 89.1C182.819 86.2 175.118 85.2 161.016 84.1C142.915 82.6 105.211 81.7 98.6101 82.5L93.0095 83.2V286V488.8L100.31 489.4C104.211 489.7 109.111 490.2 111.011 490.3C120.812 491.3 147.915 490.8 164.217 489.5ZM1112.11 350C1112.11 349.4 1111.71 348.2 1111.21 347.2C1110.31 345.5 1109.41 343.6 1105.11 333.5C1102.51 327.5 1101.01 324 1098.31 318C1097.21 315.5 1095.11 310.6 1093.61 307C1092.11 303.4 1090.01 298.5 1088.91 296C1087.91 293.5 1086.61 290.6 1086.11 289.5C1085.71 288.4 1084.41 285.5 1083.31 283C1082.21 280.5 1080.61 276.9 1079.81 275C1078.91 273.1 1076.91 268.4 1075.21 264.7C1073.51 260.9 1072.11 257.7 1072.11 257.4C1072.11 257.2 1071.21 255.1 1070.21 252.7C1065.81 243.1 1063.11 236.9 1063.11 236.5C1063.11 236.3 1061.71 233.1 1060.01 229.3C1058.31 225.6 1056.11 220.6 1055.01 218.3C1054.01 215.9 1053.11 213.8 1053.11 213.6C1053.11 213.3 1051.71 210.1 1050.01 206.3C1048.31 202.6 1046.11 197.6 1045.01 195.3C1044.01 192.9 1043.11 190.8 1043.11 190.6C1043.11 190.3 1041.81 187.3 1040.31 183.8C1038.71 180.3 1035.91 174 1034.11 169.7L1030.71 162L1029.01 165.7C1028.11 167.8 1026.11 172.2 1024.6 175.5C1023.1 178.8 1020.4 184.7 1018.6 188.5C1016.8 192.4 1014.2 198.2 1012.7 201.5C1011.1 204.8 1008.7 210.2 1007.2 213.5C1005.6 216.8 1002.2 224.5 999.502 230.5C996.802 236.6 994.402 241.7 994.002 242C993.702 242.3 993.002 243.6 992.602 245C992.202 246.4 989.801 251.8 987.401 257C984.901 262.2 981.801 269 980.4 272C974.3 285.4 972.8 288.8 970.599 293.5C969.299 296.3 967.299 300.8 966.099 303.5C964.899 306.3 962.599 311.2 961.098 314.5C959.598 317.8 955.998 325.7 953.098 332C950.197 338.3 947.297 344.8 946.497 346.4C945.697 348 945.097 349.7 945.097 350.2C945.097 350.6 982.701 351 1028.61 351C1084.31 351 1112.11 350.7 1112.11 350Z" />
                    </svg>:null}
                </OverlayIni>
                <MenuOverlay className={this.state.menuOverlay} onClick={()=>this.toggleOverlayMenu()}>
                    <div style={{paddingTop:'10px',width:'100%'}}>
                        <CloseDiv className={this.state.menuOverlay} onClick={()=>this.toggleOverlayMenu()} >
                            <img style={{height:'30px'}} alt="" src={require("./Images/crossWhite.svg")}></img>
                        </CloseDiv>
                        <Menu className={this.state.menuOverlay}>
                            <ul>
                                <li><HeadLink to="/" onClick={()=>this.toggleOverlayMenu()}>Home</HeadLink></li>
                                <li><HeadLink to="/portfolio" onClick={()=>this.toggleOverlayMenu()}>Portfolio</HeadLink></li>
                                <li><HeadLink to="/about" onClick={()=>this.toggleOverlayMenu()}>About</HeadLink></li>
                            </ul>
                        </Menu>
                    </div>
                </MenuOverlay>
            </React.Fragment>
        );
    }
}
export default Home;
